var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 23.5C10.1716 23.5 9.5 24.1716 9.5 25C9.5 25.8284 10.1716 26.5 11 26.5V23.5ZM40.0607 26.0607C40.6464 25.4749 40.6464 24.5251 40.0607 23.9393L30.5147 14.3934C29.9289 13.8076 28.9792 13.8076 28.3934 14.3934C27.8076 14.9792 27.8076 15.9289 28.3934 16.5147L36.8787 25L28.3934 33.4853C27.8076 34.0711 27.8076 35.0208 28.3934 35.6066C28.9792 36.1924 29.9289 36.1924 30.5147 35.6066L40.0607 26.0607ZM11 25V26.5H39V25V23.5H11V25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 9.5,
    y1: 6,
    x2: 40,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrow);
export default __webpack_public_path__ + "static/media/btn_arrow.3f2e40f1e9e37d60ab30d138a7d5a3ed.svg";
export { ForwardRef as ReactComponent };